export interface ITeam{
    id:string,
    name: string,
    imageUrl: string,
    totalScore: number,
    inviteCode: string,
    membersCount: number,
    members: IMemberTeam[],
    rating: number
}

export interface IMemberTeam{
    role: MemberRole,
    score: number,
    userId: number,
    firstName: string,
    lastName: string,
    photoUrl: string
}

export enum MemberRole{
    CAPTAIN = 'CAPTAIN',
    MEMBER = 'MEMBER'
}